import { render, staticRenderFns } from "./b-create-ticket.vue?vue&type=template&id=2348d4f6&scoped=true"
import script from "./b-create-ticket.vue?vue&type=script&lang=ts"
export * from "./b-create-ticket.vue?vue&type=script&lang=ts"
import style0 from "./b-create-ticket.vue?vue&type=style&index=0&id=2348d4f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348d4f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2348d4f6')) {
      api.createRecord('2348d4f6', component.options)
    } else {
      api.reload('2348d4f6', component.options)
    }
    module.hot.accept("./b-create-ticket.vue?vue&type=template&id=2348d4f6&scoped=true", function () {
      api.rerender('2348d4f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/biz/b-create-ticket.vue"
export default component.exports